let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7fOvg")).then(() => parcelRequire('fY5PU'));